module.exports = __webpack_public_path__ + "static/media/cheliangjiechedan.b152e88e.png";